import {
  GSField,
  GSInfoGroup,
  GSItemList,
  GSRadioGroup,
} from "golfstatus_react_components";
import { useEffect, useMemo, useState } from "react";
import { useDispatch } from "react-redux";
import { getFacilityCourseTees } from "../reducers/facilitySlice";
import "./course-line-item.scss";

const CourseLineItem = (props) => {
  const {
    id,
    course,
    enableTeeSelect,
    enableHoleSelect,
    holesToPlay,
    roundTees,
    availableTeesOnly,
    selectedTees,
    setSelectedTees,
  } = props;

  const { name, numberOfHoles, active } = course ?? {};

  const dispatch = useDispatch();

  const getHoles = () => {
    return [
      {
        id: 1,
        label: "All Holes",
        value: "all_holes",
        numberOfHoles: numberOfHoles,
      },
      { id: 1, label: "Front Nine", value: "front_nine", numberOfHoles: 9 },
      { id: 2, label: "Back Nine", value: "back_nine", numberOfHoles: 9 },
    ];
  };

  const [availableTees, setAvailableTees] = useState([]);
  const [roundAvailableTees, setRoundAvailableTees] = useState([]);
  const [roundTeesInitialized, setRoundTeesInitialized] = useState(false)

  const roundTeeIsActive = (tee) => {
    return availableTees?.some?.((t) => t.id === tee.id && t.active);
  };

  let currentRoundTees = useMemo(() => {
    return roundTees
      ? [
          ...roundTees?.map?.((t) => ({
            name: t?.name,
            id: t?.teeId,
            rating: t?.rating,
            slope: t?.slope,
            courseID: id,
          })),
        ]
      : [];
  }, [roundTees, id]);

  const [selectedHoles, setSelectedHoles] = useState(
    holesToPlay
      ? getHoles().find?.((h) => h.value === holesToPlay)
      : getHoles()?.[0]
  );

  useEffect(() => {
    if (course?.id && id !== undefined && enableTeeSelect) {
      dispatch(getFacilityCourseTees(course?.id)).then((response) => {
        const available =
          response?.payload?.map?.((t) => {
            return { ...t, courseID: id };
          }) ?? [];
        setAvailableTees([...available]);
      });
    }
  }, [dispatch, course.id, id, enableTeeSelect]);

  useEffect(() => {
    if (availableTeesOnly) {
      const activeTees = currentRoundTees.filter?.((tee) =>
        availableTees?.some?.((t) => t.id === tee.id && t.active)
      );
      if (activeTees.length > 0) {
        setRoundAvailableTees(activeTees, id);
      }
    } else {
      if (currentRoundTees.length > 0) {
        setRoundAvailableTees(currentRoundTees, id);
      }
    }
  }, [availableTees, currentRoundTees, availableTeesOnly, id]);

  useEffect(() => {
    if (roundAvailableTees?.length > 0 && !roundTeesInitialized) {
      setRoundTeesInitialized(true)
      setSelectedTees(roundAvailableTees, id);
    }
  }, [roundAvailableTees, setSelectedTees, id, roundTeesInitialized]);

  const getTees = () => {
    const at = availableTees?.filter?.((t) => t?.active);
    const st = [...selectedTees];
    const ft = at.filter((t) => !st.map((t2) => t2.id).includes(t.id));
    return [...st, ...ft];
  };

  const addTee = (tee) => {
    props?.teeSelected?.(id, tee);
  };

  const removeTee = (tee) => {
    props?.teeRemoved?.(id, tee);
  };

  const setHoles = (holes) => {
    setSelectedHoles(holes);
    props?.holesSelected?.(id, holes);
  };

  const getTeeItem = (item) => {
    const activeStatus = roundTeeIsActive(item) ? "" : " (Inactive)";
    return (
      <div className="tee-option">{`${item.name} - ${item.rating}/${item.slope}${activeStatus}`}</div>
    );
  };

  const getInfoGroup = () => {
    let groups = [];
    let courseInfo = {
      fit: "stretch",
      sections: [
        {
          sectionItems: [
            { type: "primary", value: name },
            { type: "secondary", value: active ? "Active" : "Inactive" },
            {
              type: "secondary",
              value: `${numberOfHoles} Hole Course`,
            },
          ],
        },
      ],
    };
    groups.push({ ...courseInfo });

    if (enableHoleSelect && numberOfHoles === 18) {
      courseInfo.sections.push?.({
        sectionItems: [
          { type: "primary", value: <GSField label="Available holes" /> },
          {
            type: "primary",
            value: (
              <GSRadioGroup
                isLtr={true}
                selectedOption={selectedHoles}
                selectionChanged={(option) => setHoles(option)}
                options={getHoles()}
              />
            ),
          },
        ],
      });
    }

    if (enableTeeSelect) {
      courseInfo.sections.push?.({
        sectionItems: [
          { type: "primary", value: <GSField label="Available tees" /> },
          {
            type: "secondary scrollable ",
            value: (
              <GSItemList
                isCheckList={true}
                type="vertical large-gap small-pad check-key-handle"
                columns="4"
                items={getTees()}
                selectedItems={selectedTees}
                itemChecked={addTee}
                itemUnchecked={removeTee}
                listItem={(item) => getTeeItem(item)}
              />
            ),
          },
        ],
      });
    }

    return groups;
  };
  return (
    <course-line-item>
      <GSInfoGroup listType="mobile-vertical" dataGroups={getInfoGroup()} />
    </course-line-item>
  );
};

export default CourseLineItem;
